import React from 'react'
import {SectionSelect} from '.'

const CountryInput = props => <SectionSelect {...props} section="COUNTRY" />

export default CountryInput
